import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button';
import moment from 'moment'
import nl2br from 'react-newline-to-break';

const PACKAGE_NAME = localStorage.getItem('package')

const NotificationItem = ({notification}) => {
    const {name, notifType, notifName, statusNotif, statusNotifDist, 
        vehicleType, licenseNo, expDate, scheduleBy, nextServiceOdo, currentOdometer, restOdo} = notification;
    let icon,icon2,icon3,notifTypeValue,nameValue,expDateValue,dayLeftValue,description = ''
    
    if (PACKAGE_NAME == "Enterprise") {
        if (notifType == "driver-reminder") {
            nameValue = `[${name}] - ${notifName}`
            notifTypeValue = "Notif Type: Driver Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'vehicle-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Vehicle Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'service-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Service Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (scheduleBy == "distance") {
                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "both") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }

                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "time") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }
            }
        } else {
            nameValue = ''
            notifTypeValue = ''
            expDateValue = ''
            dayLeftValue = ''
            icon2 = ''
            icon = ''
            icon3 = ''
        }
    } else if (PACKAGE_NAME == "Lite") {
        if (notifType == "driver-reminder") {
            nameValue = `[${name}] - ${notifName}`
            notifTypeValue = "Notif Type: Driver Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'vehicle-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Vehicle Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'service-reminder-lite') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Service Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (scheduleBy == "distance") {
                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "both") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }

                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "time") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }
            }
        } else {
            nameValue = ''
            notifTypeValue = ''
            expDateValue = ''
            dayLeftValue = ''
            icon2 = ''
            icon = ''
            icon3 = ''
        }
    } else if (PACKAGE_NAME == "Admin" || PACKAGE_NAME == "tester") {
        if (notifType == "driver-reminder") {
            nameValue = `[${name}] - ${notifName}`
            notifTypeValue = "Notif Type: Driver Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'vehicle-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Vehicle Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'service-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Service Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (scheduleBy == "distance") {
                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "both") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }

                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "time") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }
            }
        } else if (notifType == 'service-reminder-lite') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Service Reminder Lite"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (scheduleBy == "distance") {
                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "both") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }

                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "time") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }
            }
        } else {
            nameValue = ''
            notifTypeValue = ''
            expDateValue = ''
            dayLeftValue = ''
            icon2 = ''
            icon = ''
            icon3 = ''
        }
    } else {
        if (notifType == "driver-reminder") {
            nameValue = `[${name}] - ${notifName}`
            notifTypeValue = "Notif Type: Driver Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'vehicle-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Vehicle Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                icon = 'zmdi-calendar-note mdc-text-blue'
                icon3 = 'zmdi-time mdc-text-blue'
            } else {
                expDateValue = ''
                dayLeftValue = ''
                icon = ''
                icon3 = ''
            }
        } else if (notifType == 'service-reminder') {
            nameValue = `[${name} (${vehicleType})] - ${notifName}`
            notifTypeValue = "Notif Type: Service Reminder"
            if (statusNotif == 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif == 'Danger' && statusNotifDist != 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else if (statusNotif != 'Danger' && statusNotifDist == 'Danger') {
                icon2 = 'zmdi-alert-circle animated infinite wobble text-red'
            } else {
                icon2 = 'zmdi-alert-triangle animated infinite pulse text-amber'
            }

            if (scheduleBy == "distance") {
                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "both") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }

                if (nextServiceOdo != 0) {
                    description = `Next Service Odo: ${nextServiceOdo} KM
                                   Current Odometer: ${currentOdometer.toFixed(2)} KM
                                   Odometer Reminder: ${restOdo.toFixed(2)} KM`
                } else {
                    description = ''
                }
            } else if (scheduleBy == "time") {
                if (expDate !== "" && expDate !== "1900-01-01" && expDate !== "1900-01-01 00:00:00" && expDate !== "1900-01-01 00:00:00+07") {
                    expDateValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).format("YYYY-MM-DD")) : (expDate) }`
                    dayLeftValue = `${ moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true)._isValid == true ? (moment(expDate, 'YYYY-MM-DD HH:mm:ssZ', true).fromNow()) : (moment(expDate, 'YYYY-MM-DD', true).fromNow()) }`
                    icon = 'zmdi-calendar-note mdc-text-blue'
                    icon3 = 'zmdi-time mdc-text-blue'
                } else {
                    expDateValue = ''
                    dayLeftValue = ''
                    icon = ''
                    icon3 = ''
                }
            }
        } else {
            nameValue = ''
            notifTypeValue = ''
            expDateValue = ''
            dayLeftValue = ''
            icon2 = ''
            icon = ''
            icon3 = ''
        }
    }

    return (
        <li className="media">
            { icon2 != "" ? (<i className={`zmdi ${icon2} zmdi-hc-fw zmdi-hc-2x`}/>) : (null)}
            <div className="media-body align-self-center">
                { nameValue != "" ? (<p className="sub-heading mb-0">{nameValue}</p>) : (null)}
                { licenseNo != "" ? (<p className="sub-heading mb-0">License No: {licenseNo}</p>) : (null)}
                { notifType != "" ? (<p className="sub-heading mb-0">{notifTypeValue}</p>) : (null)}
                { description != "" ? (<p className="sub-heading mb-0">{nl2br(description)}</p>) : (null)}
                { expDateValue != "" ? (
                    <div className="media-body align-self-center">
                        { icon != "" ? (
                            <p className="sub-heading mb-0">
                                <Button size="small" className="jr-btn jr-btn-xs mb-0">
                                    <i className={`zmdi ${icon} zmdi-hc-fw`}/>
                                </Button>
                                <span className="meta-date">
                                    <small>{expDateValue}</small>
                                </span>
                            </p>
                        ) : (null)}
                        { icon3 != "" ? (
                            <p className="sub-heading mb-0">
                                <Button size="small" className="jr-btn jr-btn-xs mb-0">
                                    <i className={`zmdi ${icon3} zmdi-hc-fw`}/>
                                </Button>
                                <span className="meta-date">
                                    <small>{dayLeftValue}</small>
                                </span>
                            </p>
                        ) : (null)}
                    </div>
                ) : (null)}
            </div>
        </li>
    );
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./components/AppNotificationDoc/NotificationItem.js